const theme = {
  global: {
    font: {
      family: 'Arial',
      size: '14px',
      height: '20px',
    },
    control: {
      border: {
        radius: '4px',
      },
    },
    breakpoints: {
      small: { value: 768 },
      medium: { value: 1536 },
      large: { value: 1537 },
    },
  },
};

export default theme;
